import React, { useEffect, useState } from 'react';
import { Card, Form, Modal, Spinner } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import { InfoCircle } from 'iconsax-react';
import MyApiClient from '../../../../../api-client/MyApiClient';

const emptyForm = {
    nome: '', cognome: '', luogoNascita: '', birthdate: '', codiceFiscale: '',
    indirizzo: '', cap: '', citta: '', provincia: '',
};

const Req = () => <span className="text-danger"> *</span>;

const clean = (s) => (s || '').replace(/\s+/g, '');

const AggiungiJunior = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const preParentId = searchParams.get('parentId');
    const preParentName = searchParams.get('parentName');
    const playerId = searchParams.get('playerId');
    // Se arrivo da una vendita manuale, torno lì col junior creato selezionato.
    const returnTo = searchParams.get('returnTo');

    const [customers, setCustomers] = useState([]);
    const [createdJunior, setCreatedJunior] = useState(null);
    const [selectedPlayer, setSelectedPlayer] = useState(
        preParentId ? { value: preParentId, label: preParentName || 'Player selezionato' } : null
    );
    const [form, setForm] = useState(emptyForm);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('success');

    // Carica i player della struttura una volta (per la ricerca)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (!tokenDetailsString) return;
                const token = JSON.parse(tokenDetailsString).idToken;
                const apiClient = new MyApiClient();
                const data = await apiClient.getCustomers(token);
                if (data && data.items) {
                    setCustomers(data.items.map((c) => ({
                        value: c.customerUserId,
                        label: c.name + (c.email ? ` (${c.email})` : ''),
                    })));
                }
            } catch (e) {
                console.error('Errore caricamento player:', e);
            }
        };
        fetchData();
    }, []);

    const loadPlayerOptions = (inputValue) =>
        new Promise((resolve) => {
            if (!inputValue || inputValue.trim().length < 3) {
                resolve([]);
                return;
            }
            const q = inputValue.toLowerCase();
            resolve(customers.filter((c) => c.label.toLowerCase().includes(q)));
        });

    const update = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors((prev) => {
                const n = { ...prev };
                delete n[field];
                return n;
            });
        }
    };

    const validate = () => {
        const e = {};
        if (!selectedPlayer) e.player = 'Seleziona il Player di riferimento';

        const req = (f, msg) => { if (!form[f] || !String(form[f]).trim()) e[f] = msg; };
        req('nome', 'Il nome è obbligatorio');
        req('cognome', 'Il cognome è obbligatorio');
        req('luogoNascita', 'Il luogo di nascita è obbligatorio');
        req('birthdate', 'La data di nascita è obbligatoria');
        req('codiceFiscale', 'Il codice fiscale è obbligatorio');
        req('indirizzo', "L'indirizzo è obbligatorio");
        req('cap', 'Il CAP è obbligatorio');
        req('citta', 'La città è obbligatoria');
        req('provincia', 'La provincia è obbligatoria');

        if (form.codiceFiscale.trim() && !/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i.test(form.codiceFiscale.trim())) {
            e.codiceFiscale = 'Controlla il formato del codice fiscale (16 caratteri, es. RSSMRA85M01H501Z)';
        }
        if (form.cap.trim() && !/^\d{5}$/.test(form.cap.trim())) {
            e.cap = 'Il CAP deve avere 5 cifre';
        }
        if (form.provincia.trim() && !/^[A-Za-z]{2}$/.test(form.provincia.trim())) {
            e.provincia = 'Sigla provincia di 2 lettere (es. AV)';
        }
        if (form.birthdate) {
            const d = new Date(form.birthdate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (isNaN(d.getTime())) e.birthdate = 'Data non valida';
            else if (d > today) e.birthdate = 'La data non può essere nel futuro';
        }

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSave = async () => {
        if (!validate()) return;

        setLoading(true);
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) {
                setModalMessage('Sessione non valida. Effettua di nuovo il login.');
                setModalType('error');
                setShowModal(true);
                return;
            }
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();

            const username = `${clean(form.nome)}${clean(form.cognome)}${Math.floor(100000 + Math.random() * 900000)}`;

            const junior = {
                locale: 'it-IT',
                givenName: form.nome.trim(),
                familyName: form.cognome.trim(),
                username,
                birthdate: form.birthdate,
                birthPlace: form.luogoNascita.trim(),
                taxCode: form.codiceFiscale.trim().toUpperCase(),
                address: {
                    streetAddress: form.indirizzo.trim(),
                    locality: form.citta.trim(),
                    postalCode: form.cap.trim(),
                    province: form.provincia.trim().toUpperCase(),
                    country: 'IT',
                },
            };

            const response = await apiClient.createClubJunior(token, {
                parentId: selectedPlayer.value,
                junior,
            });

            if (response && response.error) {
                const detail = (response.error && (response.error.detail || response.error)) || 'Errore durante il salvataggio del Junior.';
                setModalMessage(typeof detail === 'string' ? detail : 'Errore durante il salvataggio del Junior.');
                setModalType('error');
                setShowModal(true);
                return;
            }

            const newJuniorId = response?.data?.userId;
            setCreatedJunior(newJuniorId ? { id: newJuniorId, name: `${form.nome.trim()} ${form.cognome.trim()}` } : null);
            setModalMessage('Junior salvato con successo.');
            setModalType('success');
            setShowModal(true);
            setForm(emptyForm);
        } catch (error) {
            setModalMessage('Errore durante il salvataggio del Junior. Riprova.');
            setModalType('error');
            setShowModal(true);
        } finally {
            setLoading(false);
        }
    };

    const goBack = () => {
        if (returnTo && createdJunior) {
            const sep = returnTo.includes('?') ? '&' : '?';
            navigate(`${returnTo}${sep}newJuniorId=${encodeURIComponent(createdJunior.id)}&newJuniorName=${encodeURIComponent(createdJunior.name)}`);
        } else if (returnTo) {
            navigate(returnTo);
        } else if (playerId) {
            navigate(`/struttura/clienti/player_profile/${playerId}?tab=junior`);
        } else {
            navigate('/struttura/junior/list');
        }
    };

    const closeModal = () => {
        setShowModal(false);
        if (modalType === 'success') goBack();
    };

    const field = (name, label, { type = 'text', maxLength, placeholder = '' } = {}) => (
        <Form.Group className="mb-3">
            <Form.Label>{label}<Req /></Form.Label>
            <Form.Control
                type={type}
                value={form[name]}
                maxLength={maxLength}
                placeholder={placeholder}
                onChange={(e) => update(name, e.target.value)}
                isInvalid={!!errors[name]}
            />
            <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback>
        </Form.Group>
    );

    return (
        <>
            <div className="sid-form-narrow">
            <div className="sid-info-banner">
                <span className="sid-info-banner__icon"><InfoCircle size={22} variant="Bulk" /></span>
                <div className="sid-info-banner__body">
                    <div className="sid-info-banner__title">Profilo Junior abbinato a un Player senior</div>
                    <p>I dati del Junior possono essere modificati dal Player senior a cui è abbinato tramite l'applicazione Sportid Player.</p>
                </div>
            </div>

            <Card>
                <Card.Header><Card.Title>Player di riferimento</Card.Title></Card.Header>
                <Card.Body>
                    <Form.Group>
                        <Form.Label>Cerca Player<Req /></Form.Label>
                        <AsyncSelect
                            cacheOptions
                            defaultOptions={false}
                            value={selectedPlayer}
                            loadOptions={loadPlayerOptions}
                            onChange={(opt) => { setSelectedPlayer(opt); setErrors((p) => { const n = { ...p }; delete n.player; return n; }); }}
                            placeholder="Inizia a digitare per cercare un Player (minimo 3 caratteri)…"
                            noOptionsMessage={({ inputValue }) => (inputValue && inputValue.length >= 3 ? 'Nessun Player trovato' : 'Digita almeno 3 caratteri')}
                            isClearable
                        />
                        {errors.player && <div className="text-danger mt-1" style={{ fontSize: '0.875em' }}>{errors.player}</div>}
                        <Form.Text className="text-muted">Cerca per nome o cognome tra i Player della Struttura.</Form.Text>
                    </Form.Group>
                </Card.Body>
            </Card>

            <Card>
                <Card.Header><Card.Title>Dati anagrafici</Card.Title></Card.Header>
                <Card.Body>
                    <Form onSubmit={(e) => e.preventDefault()}>
                        {field('nome', 'Nome')}
                        {field('cognome', 'Cognome')}
                        {field('luogoNascita', 'Luogo di nascita')}
                        {field('birthdate', 'Data di nascita', { type: 'date' })}
                        {field('codiceFiscale', 'Codice fiscale', { maxLength: 16 })}
                        {field('indirizzo', 'Indirizzo')}
                        {field('cap', 'CAP', { maxLength: 5 })}
                        {field('citta', 'Città')}
                        {field('provincia', 'Provincia', { maxLength: 2, placeholder: 'es. AV' })}
                    </Form>
                </Card.Body>
            </Card>

            <div className="sid-form-actions d-flex justify-content-end gap-2 mt-1 mb-4">
                <button type="button" className="btn sid-btn-ghost" onClick={goBack}>Annulla</button>
                <button type="button" className="btn btn-primary" onClick={handleSave} disabled={loading}>
                    {loading ? 'Salvataggio…' : 'Salva Junior'}
                </button>
            </div>
            </div>

            <Modal show={showModal} onHide={closeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'success' ? 'Successo' : 'Errore'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={closeModal}>Chiudi</button>
                </Modal.Footer>
            </Modal>

            <Modal show={loading} centered backdrop="static">
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>
                    <div className="mt-2">Salvataggio in corso…</div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AggiungiJunior;
